import { CreateReferralForm } from "./CreateReferralForm";

interface Referral {
  id: string | number;
  referralNumber?: string; // Unique 10-digit referral number
  memberMedicaidId: string;
  memberName: string;
  dateOfBirth: string;
  zipCode: string;
  preferredLanguage: string;
  phoneNumber?: string;
  email?: string;
  streetAddress?: string;
  city?: string;
  state?: string;
  country?: string;
  healthPlan: string;
  planType: "Managed Care" | "Fee-for-Service";
  referringProvider: {
    name: string;
    npi: string;
    organization: string;
    phone: string;
  };
  primaryDiagnosis: string;
  riskScore?: number;
  sdohNeeds: string[];
  housingSubcategories?: string[];
  transportationSubcategories?: string[];
  urgencyLevel: "Immediate" | "Within 24h" | "Within 1 Week" | "Routine";
  availability?: string;
  additionalNotes?: string;
  authorizationRequired: boolean;
  consentObtained: boolean;
  hipaaCompliant: boolean;
  timeline: string;
  status: "Pending" | "Matched" | "Auto-Matched" | "Accepted" | "Authorized" | "In Progress" | "On Hold" | "Completed";
  createdAt: string;
  useMatchingEngine: boolean;
}

interface ReferralEditFormProps {
  referral: Referral;
  onSubmit: (referral: Referral) => Promise<boolean>;
  onCancel: () => void;
  onBack?: () => void;
}

export function ReferralEditForm({ referral, onSubmit, onCancel, onBack }: ReferralEditFormProps) {
  const handleSubmit = async (updatedReferral: Referral) => {
    // Preserve the original ID and created date when editing
    const referralWithOriginalData = {
      ...updatedReferral,
      id: referral.id,
      createdAt: referral.createdAt,
    };

    return await onSubmit(referralWithOriginalData);
  };

  // This component wraps CreateReferralForm but with edit mode enabled
  // We'll pass the existing referral data as initial values
  // For now, this is a simplified version - you would need to modify
  // CreateReferralForm to accept initialData prop for pre-population

  return (
    <CreateReferralForm
      onSubmit={handleSubmit}
      onCancel={onCancel}
      onBack={onBack}
      initialData={referral}
      isEditMode={true}
    />
  );
}

export default ReferralEditForm;
